import { render, staticRenderFns } from "./DoctorScheduleSection.vue?vue&type=template&id=f188e9c8"
import script from "./DoctorScheduleSection.vue?vue&type=script&lang=js"
export * from "./DoctorScheduleSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports